/**
 * Created by asiulik on 15.05.2017.
 */

define(['jquery', 'lodash', 'eventEmitter/EventEmitter', './finderFilters', './finderConst', './finderMap', './finderMarkers', './finderContent', '../../utils', '../../core/cookies'], function ($, _, EventEmitter, FinderFilters, FinderConst, FinderMap, FinderMarkers, FinderContent, Utils, Cookies) {

    function Finder($finder, layoutInstace) {
        this.$finder = $finder;
        this.layout = layoutInstace;
    }

    function getFilteredMarkers(markersCollection, inputValue, key){

        return markersCollection.filter(function(marker) {
            var shoudBeReturn = false;

            var arr = marker[key].split(',');

            arr.forEach(function(code){
                if(code.match(inputValue)){
                    shoudBeReturn = true;
                }
            });

            return shoudBeReturn;
        })

    }

    Finder.prototype.init = function () {

        var _this = this;

        if (!this.$finder.length) return;
        var urlBerforeInit = window.location.href;

        this.initBase();
        this.initMap();

        this.finderFilters = new FinderFilters(this.$finder);

        this.finderFilters.on('finder:filter:set', function(value, config) {

            var currentUrl = window.location.href;
            var currentValue = Utils.getQueryStringParams(config.queryParamName, currentUrl);
            currentUrl = Utils.removeURLParameter(currentUrl, config.queryParamName);

            if(value) {
                currentUrl = Utils.addQueryStringParamsToUrl(config.queryParamName, value, currentUrl);
            }

            history.replaceState({}, '', currentUrl);

        });

        const head = document.getElementsByTagName("head")[0];
        const insertBefore = head.insertBefore;
        if (head instanceof HTMLHeadElement) {
            head.insertBefore = function (newElement, referenceElement) {
                if (newElement instanceof HTMLLinkElement) {
                    if (newElement.href && newElement.href.indexOf("//fonts.googleapis.com/css?family=") > -1) {
                        return;
                    }
                }
                insertBefore.call(head, newElement, referenceElement);
            };
        }

        this.finderFilters.init();
        if (navigator.geolocation && _this.$finder[0].hasAttribute('data-geolocation')) {

            navigator.geolocation.getCurrentPosition(function(position){
                var currentUrl = urlBerforeInit;

                if( (Utils.getQueryStringParams('latitude', currentUrl) && Utils.getQueryStringParams('longitude', currentUrl)) || Utils.getQueryStringParams('country', currentUrl) || Utils.getQueryStringParams('postcode', currentUrl) )
                    return;
                $('.preloader--map').removeClass('preloader--hidden');
                var $currentMapContainer = _this.$finder.find(FinderConst.finderMapSelector);

                currentUrl = Utils.addQueryStringParamsToUrl('latitude',position.coords.latitude.toFixed(3), currentUrl);
                currentUrl = Utils.addQueryStringParamsToUrl('longitude', position.coords.longitude.toFixed(3), currentUrl);

                Utils.getPageByAjax(currentUrl).then(function(response){

                    $('.preloader--map').addClass('preloader--hidden');

                    var $response = $(response);
                    var $locationContainer = $response.find('#locations');

                    _this.$finder.find('#locations').html($locationContainer.html());

                    _this.finderFilters.$selectFilter.html($response.find('[data-finder-select-filter]').html());
                    _this.finderFilters.$selectFilter.material_select();

                    currentUrl = Utils.addQueryStringParamsToUrl('country', _this.finderFilters.$selectFilter.val(), currentUrl);

                    $currentMapContainer.html($response.find(FinderConst.finderMapSelector).html())

                    _this.initBase();
                    _this.initMap();

                    history.replaceState({}, '', currentUrl);

                    $currentMapContainer.css('opacity', 1);
                });

            });
        }

        this.finderFilters.on('finder:filter:change', function(value, config) {
            var currentUrl = window.location.href;
            var currentValue = Utils.getQueryStringParams(config.queryParamName, currentUrl);
            currentUrl = Utils.removeURLParameter(currentUrl, 'latitude');
            currentUrl = Utils.removeURLParameter(currentUrl, 'longitude');
            currentUrl = Utils.removeURLParameter(currentUrl, config.queryParamName);

            if(value) {
                currentUrl = Utils.addQueryStringParamsToUrl(config.queryParamName, value, currentUrl);
            }

            var $currentMapContainer = _this.$finder.find(FinderConst.finderMapSelector);


            $('.preloader--map').removeClass('preloader--hidden');

            Utils.getPageByAjax(currentUrl).then(function(response){

                $('.preloader--map').addClass('preloader--hidden');

                var $response = $(response);
                var $locationContainer = $response.find('#locations');

                _this.$finder.find('#locations').html($locationContainer.html());
                $currentMapContainer.html($response.find(FinderConst.finderMapSelector).html())

                _this.initBase();
                _this.initMap();

                history.replaceState({}, '', currentUrl);

                $currentMapContainer.css('opacity', 1);
            });
        });

    };

    Finder.prototype.initBase = function(){

        var _this = this;

        this.finderContent = new FinderContent(this.$finder);
        this.finderConfig = this.$finder.data('finderConfig') ? this.$finder.data('finderConfig') : {};

        this.markerConfig = {
            defaultIconMarkerPath: this.$finder.data('markerDefault'),
            activeIconMarkerPath: this.$finder.data('markerActive')
        };

        this.mapConfig = {
            mapPreloaderSelector: _this.$finder.find(FinderConst.finderMapPreloaderSelector)
        };

        if (this.finderConfig.disableMap) {
            _this.disableMap();
        }

    };

    Finder.prototype.initMap = function(){

        var _this = this;

        this.finderMap = new FinderMap(this.$finder, FinderConst.finderMapSelector, this.mapConfig);
        this.finderMap.on('finder.map.inited', function () {
            _this.finderMarkers = new FinderMarkers(_this.$finder, _this.finderMap.getMap(), _this.markerConfig);
            _this.finderMarkers.init();

            _this.finderMap.centerMapByMarkersPosition(_this.finderMarkers.getMarkers(true));
            _this.finderMap.checkMaxZoomIsCorrect();

            if (_this.displayOnInit()) {
                _this.displayOnInitAction();
            }

            _this.bindEvents();

        });
        this.finderMap.init();

    };

    Finder.prototype.displayMarkerContentOnCondition = function(markersColletion){

        if(markersColletion.length == 1) {

            var marker = markersColletion[0];

            this.finderMarkers.clearAllSelected();
            this.finderMarkers.activeMarker = marker.markerMapReference;
            this.finderMarkers.setActive(marker.markerMapReference);

            this.finderContent.showContent(marker.markerMapReference.contentId).then(function(response) {
            });
        }

    };

    Finder.prototype.displayOnInitAction = function() {

        var _this = this;
        var markerDisplayOnInit = this.finderMarkers.getMarkerByContentId(this.displayOnInit());
        if(markerDisplayOnInit) {
            _this.finderMarkers.disableMarker(
                markerDisplayOnInit
            );

            this.finderMarkers.setActive(markerDisplayOnInit);

            this.finderContent.showContent(this.displayOnInit()).then(function () {
                _this.finderMap.resizeMap();
                _this.finderMap.panTo(markerDisplayOnInit.getPosition())
            })
        }

    };

    Finder.prototype.disableMap = function () {
        return _.assign(this.mapConfig, {
            scrollwheel: false,
            navigationControl: false,
            mapTypeControl: false,
            scaleControl: false,
            draggable: false,
            disableDoubleClickZoom: true
        });
    };


    Finder.prototype.displayOnInit = function () {
        return this.$finder.data('displayOnInit');
    };

    Finder.prototype.bindEvents = function () {

        var _this = this;

        _this.finderMarkers.on('finder.markers.markerClicked', function (markerInstance) {

            try {

                $('#toggleMobileListButton').addClass('input-field--active');
                $('.finder__markers').addClass('finder__markers--show');

            } catch(e){
                // console.log('send marker dataLayer error: ', e);
            }

            _this.finderContent.showContent(markerInstance.contentId).then(function(response) {

            });

        });

        _this.finderMarkers.on('finder.markers.hideMarker', function () {

            _this.finderContent.hideContent().then(function() {
                 _this.finderMap.resizeMap();
            });

        });

        _this.finderContent.on('finder.content.closeContent', function () {

            if (_this.finderConfig.disableMap) return;

            _this.finderContent.hideContent().then(function(response) {
                 _this.finderMap.resizeMap();
            });

            _this.finderMarkers.clearAllSelected();

        });

        if(this.layout) {

            this.layout.on('reload', function(){

                _this.finderMap.centerMapByMarkersPosition(_this.finderMarkers.getMarkers(true));
                _this.finderMap.checkMaxZoomIsCorrect();
            });

        }

    };

    return Finder;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/finder/finder.js